(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire8c83"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire8c83"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("7PKI7", function(module, exports) {

$parcel$export(module.exports, "bootBlock", function () { return $5b418790771612cf$export$3ba659c19d85cb2f; });
$parcel$export(module.exports, "scoped", function () { return $5b418790771612cf$export$6387ff77edd805b9; });
$parcel$export(module.exports, "claim", function () { return $5b418790771612cf$export$dac5a380ed022e46; });
$parcel$export(module.exports, "listenWhileConnected", function () { return $5b418790771612cf$export$1739974940b15ce8; });
/**
 * Shared boot for the theme block scripts (blocks/*).
 *
 * Every block script keeps its behavior in one initializer, `initialize(root, options)`:
 * - Frontend: called once with the whole document after DOMContentLoaded (or right away when the document
 *   is already parsed), or after `load` for scripts that always waited for it.
 * - Block editor canvas: handed to the canvas runtime (inc/Blocks/block-canvas.js), which calls it with the
 *   preview root after every ACF preview render, with { isEditor: true, autoplay: false }.
 *
 * ACF re-renders previews by reconciling the same DOM, so initializers run repeatedly: bind through claim()
 * so each element is wired once, and remove window/document listeners when the block leaves the canvas.
 */ function $5b418790771612cf$export$3ba659c19d85cb2f(slug, initialize) {
    var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, _ref_waitFor = _ref.waitFor, waitFor = _ref_waitFor === void 0 ? 'DOMContentLoaded' : _ref_waitFor;
    if (window.juniperBlockRuntime) {
        window.juniperBlockRuntime.register(slug, initialize);
        return;
    }
    var run = function() {
        return initialize(document, {
            isEditor: false,
            autoplay: true
        });
    };
    if (waitFor === 'load') {
        if (document.readyState === 'complete') run();
        else window.addEventListener('load', run, {
            once: true
        });
    } else if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, {
        once: true
    });
    else run();
}
function $5b418790771612cf$export$6387ff77edd805b9(root, selector) {
    return root.nodeType === Node.DOCUMENT_NODE ? selector : root.querySelector(selector);
}
function $5b418790771612cf$export$dac5a380ed022e46(element) {
    var key = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'juniperReady';
    if (!element || element.dataset[key] === 'true') return false;
    element.dataset[key] = 'true';
    return true;
}
function $5b418790771612cf$export$1739974940b15ce8(target, type, handler, owner, options) {
    var listener = function(event) {
        if (!owner.isConnected) {
            target.removeEventListener(type, listener, options);
            return;
        }
        handler(event);
    };
    target.addEventListener(type, listener, options);
}

});


var $7PKI7 = parcelRequire("7PKI7");
var $3ce46050608c9cb3$var$blogPostsPagination = {
    init: function init(root) {
        this.hideArrowMobile(root);
    },
    hideArrowMobile: function(root) {
        var categories = root.querySelector('.blog-posts-pagination__categories');
        if (!(0, $7PKI7.claim)(categories, 'juniperArrow')) return;
        function hideArrow() {
            categories.classList.add('var_hide_arrow');
            categories.removeEventListener('scroll', hideArrow);
        }
        categories.addEventListener('scroll', hideArrow);
    }
};
(0, $7PKI7.bootBlock)('blog-posts-pagination', function(root) {
    return $3ce46050608c9cb3$var$blogPostsPagination.init(root);
});

})();
//# sourceMappingURL=script.js.map
